@if (!isIconBtn) {
  <p class="floori-button-inner">
    <ng-content></ng-content>
  </p>
}
<ng-content select="floori-icon"></ng-content>
